<template>
    <div class="w280">
        <div class="proLeftBox" v-if="sessionList && sessionList.length">
            <h3 class="boxTit"><span>{{companyName}}</span><i>其余拍卖专场</i>
                <a :href="'javascript:;'" v-if="$route.query.from">更多</a>
                <a :href="'/org_detail/'+companyId" v-else target="_blank">更多</a>
            </h3>
            <div class="sessionListR">
                <template v-for="(item,i) in sessionList">
                    <a :href="'javascript:;'" v-if="$route.query.from==1" :key="i">
                        <dl>
                            <dt><span>
                                    {{item.name}}
                                </span></dt>
                            <dd>
                                <template v-for="(info,k) in item.extraInfo">
                                    <span v-if="info.label=='拍卖时间'" :key="k">{{info.text}}</span>
                                </template>
                            </dd>
                        </dl>
                    </a>
                    <a :href="'/special_detail/'+item.specialCode+'?from=2'" v-else-if="$route.query.from == 2" :key="i">
                        <dl>
                            <dt><span>
                                    {{item.name}}
                                </span></dt>
                            <dd>
                                <template v-for="(info,k) in item.extraInfo">
                                    <span v-if="info.label=='拍卖时间'" :key="k">{{info.text}}</span>
                                </template>
                            </dd>
                        </dl>
                    </a>
                    <a :href="'/special_detail/'+item.specialCode" v-else :key="i" target="_blank">
                        <dl>
                            <dt><span>
                                    {{item.name}}
                                </span></dt>
                            <dd>
                                <template v-for="(info,k) in item.extraInfo">
                                    <span v-if="info.label=='拍卖时间'" :key="k">{{info.text}}</span>
                                </template>
                            </dd>
                        </dl>
                    </a>
                </template>

            </div>
        </div>
        <div class="proLeftBox mt30" v-if="otherPreList && otherPreList.length">
            <h3 class="boxTit"><span>预展拍品推荐</span>
                <a :href="'javascript:;'" v-if="$route.query.from ">更多</a>
                <a :href="'/preauction?status=0&page=1&ord=6&organ_code='+companyId+'&citys=&organName='+encodeURIComponent(companyName)+'&item=&is_total=1'" target="_blank" v-else>更多</a>
            </h3>
            <div class="aucList">
                <template v-for="(item,i) in otherPreList">
                    <dl :key="i">
                        <dt>
                            <a :href="'javascript:;'" v-if="$route.query.from == 1">
                            <div class="imgBox">
                                <el-image
                                    style="width: 100%; height: 100%;object-fit: cover"
                                    :src="item.Cover"
                                    fit="contain"
                                >
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="el-image__error">
                                        <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                    </div>
                                </el-image>
                            </div>
                            </a>
                            <a :href="'/paimai-'+item.ArtCode+'?from=2'" v-else-if="$route.query.from == 2">
                                <div class="imgBox">
                                    <el-image
                                        style="width: 100%; height: 100%;object-fit: cover"
                                        :src="item.Cover"
                                        fit="contain"
                                    >
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                </div>
                            </a>
                            <a :href="'/paimai-'+item.ArtCode" target="_blank" v-else>
                                <div class="imgBox">
                                    <el-image
                                        style="width: 100%; height: 100%;object-fit: cover"
                                        :src="item.Cover"
                                        fit="contain"
                                    >
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                </div>
                            </a>
                        </dt>
                        <dd>
                            <h3 class="name">
                                <a :href="'javascript:;'" v-if="$route.query.from == 1">{{item.Title}}</a>
                                <a :href="'/paimai-'+item.ArtCode+'?from=2'" v-else-if="$route.query.from == 2">{{item.Title}}</a>
                                <a :href="'/paimai-'+item.ArtCode" target="_blank" v-else>{{item.Title}}</a>

                            </h3>
                            <p><span>估价：</span><strong class="item-red">{{item.CurrencyType}} {{formatMoney(item.OriginalEvaluation)}}<template v-if="item.LastEvaluation">-{{formatMoney(item.LastEvaluation)}}</template></strong></p>
                            <p><span>拍卖公司：</span><strong>{{item.organ_name}}</strong></p>
                            <p><span>拍卖会：</span><strong>
                                <a :href="'javascript:;'" v-if="$route.query.from == 1">{{item.session_name}}</a>
                                <a :href="'/meeting_detail/'+item.session_code+'?from=2'" v-else-if="$route.query.from == 2">{{item.session_name}}</a>
                                <a :href="'/meeting_detail/'+item.session_code" target="_blank" v-else>{{item.session_name}}</a>
                            </strong></p>
                        </dd>
                    </dl>
                </template>
            </div>
        </div>
        <div class="proLeftBox mt30" v-if="artistList && artistList.length">
            <h3 class="boxTit"><span>艺术家推荐</span>
                <a href="javascript:;" v-if="$route.query.from">更多</a>
                <a href="//artist.artron.net" target="_blank" v-else>更多</a>
            </h3>
            <div class="artistList">
                <ul class="first">
                    <template v-for="(item,i) in artistList">
                        <li v-if="i<3" :key="i">
                            <a :href="item.url" v-if="$route.query.from">
                                <div class="imgBox">
                                    <el-image
                                        style="width: 100%; height: 100%;object-fit: cover"
                                        :src="item.picture"
                                        fit="contain"
                                    >
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                </div>
                                <div class="name">{{item.title}}</div>
                            </a>
                            <a :href="item.url" target="_blank" v-else>
                                <div class="imgBox">
                                    <el-image
                                        style="width: 100%; height: 100%;object-fit: cover"
                                        :src="item.picture"
                                        fit="contain"
                                    >
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                </div>
                                <div class="name">{{item.title}}</div>
                            </a>
                        </li>
                    </template>
                </ul>
                <ul class="second">
                    <template v-for="(item,i) in artistList">
                    <li v-if="i>2" :key="i">
                        <a :href="item.url" target="_blank">{{item.title}}</a>
                    </li>
                    </template>
                </ul>
            </div>
        </div>
        <div class="proLeftBox mt30" v-if="newsList && newsList.length">
            <h3 class="boxTit">
                <span>相关资讯</span>
                <template v-for="(m,k) in extraInfo">
                    <strong :key="k" v-if="m.label=='作者'" class="fr">
                        <template v-for="(author,j) in m.isSample">
                        <a :href="'https://artso.artron.net/auction/search_auction.php?keyword='+author.name" target="_blank" :key="j" v-if="j==0 && $route.query.from">更多</a>
                        <a :href="'https://artso.artron.net/auction/search_auction.php?keyword='+author.name" target="_blank" :key="j" v-else-if="j==0">更多</a>
                        </template>
                    </strong>

                </template>
            </h3>
            <div class="newsList">
                <ul class="first">
                    <li v-for="(item,i) in newsList" :key="i">
                        <a :href="'javascript:;'" v-if="$route.query.from">
                            <div class="title">{{item.title}}</div>
                            <div class="time">{{item.publish_at}}</div>
                        </a>
                        <a :href="item.link" target="_blank" v-else>
                            <div class="title">{{item.title}}</div>
                            <div class="time">{{item.publish_at}}</div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { getReco} from "@/api/product/detail";

export default {
    props:{
        otherPreList:{
            type:Array
        },
        newsList:{
            type:Array
        },
        sessionList:{
            type:Array
        },
        companyName:{
            type:String
        },
        companyId:{
            type:String
        },
        extraInfo:{
            type:Array
        },
        speId:{
            type:String
        },
        t:{
            type:Number
        }
    },
    name: "ProductRight",
    data(){
        return{
            artistList:[],
            artistSec:[]
        }
    },
    mounted() {
        this.getProArtist()
    },
    methods:{
        formatMoney (number){
            let decimals = 0,
                decPoint = '.',
                thousandsSep = ','
            number = (number + '').replace(/[^0-9+-Ee.]/g, '')
            let n = !isFinite(+number) ? 0 : +number
            let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
            let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
            let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
            let s = ''
            let toFixedFix = function (n, prec) {
                let k = Math.pow(10, prec)
                return '' + Math.ceil(n * k) / k
            }
            s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
            let re = /(-?\d+)(\d{3})/
            while (re.test(s[0])) {
                s[0] = s[0].replace(re, '$1' + sep + '$2')
            }
            if ((s[1] || '').length < prec) {
                s[1] = s[1] || ''
                s[1] += new Array(prec - s[1].length + 1).join('0')
            }
            return s.join(dec)
        },
        getProArtist(){
            let param = {
                cms_module_id:4
            }
            getReco(param).then((res) => {
                if(res.code == 0){
                    this.artistList = res.data.list
                }
            })
        },

    }
}
</script>

<style scoped lang="scss">
.proLeftBox{border:1px solid #D9D9D9;
    .boxTit{line-height: 66px;border-bottom:1px solid #d9d9d9;padding:0 20px;overflow: hidden;
        span{font-size: 18px;font-weight: bold;float:left;margin-right: 10px;}
        i{color:#595959;font-size: 14px;}
        a{float:right;color:#8C8C8C;}
        a:hover{color:#329D15;}
    }
}
.sessionListR{padding:0 20px;
    a{display:block;border-bottom: 1px solid rgba(0,0,0,.06);}
    a:last-child{margin-bottom: 0;}
    dt{line-height: 24px;font-size: 16px;padding:20px 0 10px;}
    dd{line-height: 22px;padding-bottom: 20px;color:#8C8C8C;}
}
.aucList{padding:0 20px;
    dl{padding:20px 0;border-bottom: 1px solid rgba(0,0,0,.06);}
    dl:last-child{border-bottom:0}
    dt{background-color: #F2F2F2;height:0;position: relative;margin-bottom: 10px;transition: .2s height ease-in-out;overflow: hidden;}
    dl:hover dt{height:180px;}
    dd{
        .name{line-height: 24px;font-size: 16px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;margin-bottom: 10px;}
        p{line-height: 22px;margin-bottom: 4px;color:#262626;display:flex;
            span{color:#8C8C8C;width:72px;}
            strong{width:168px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}
            .item-red{color:#f5222d;}
        }
        p:last-child{margin-bottom: 0;}
    }
}
.artistList{padding:0 20px 20px;
    .first{overflow: hidden;border-bottom: 1px solid #D9D9D9;padding:20px 0;
        li{float:left;width:75px;margin-right: 6px;text-align: center;}
        li:last-child{margin-right: 0px;}
        .imgBox{width:75px;height:75px;overflow: hidden;border-radius: 4px;}
        .name{margin-top: 10px;}
    }
    .second{overflow: hidden;padding-top: 10px;
        li{width:70px;margin-right: 14px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;margin-top: 10px;float:left;}
        li:nth-child(3n){margin-right: 0;}
    }
}
.newsList{padding:0 20px;
    li{border-bottom: 1px solid #d9d9d9;padding-bottom: 20px;
        .title{line-height: 24px;font-size: 16px;padding:20px 0 10px;}
        .time{color:#8C8C8C;}
    }
    li:last-child{border-bottom: 0;}
}
</style>